<template>
  <div class="detail-container">
    <h1>測定種別情報詳細</h1>
    <div v-if="measure_type">
      <table class="table table-bordered">
        <tr>
          <th>測定種別</th>
          <td>{{ measure_type.measure_type_nm }}</td>
        </tr>
        <tr>
          <th>並び順</th>
          <td>{{ measure_type.sort_no }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'MeasureTypeList', params: { id: measure_type.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <!-- <router-link :to="{ name: 'MeasureTypeEdit', params: { id: measure_type.id }}">
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link> -->
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      測定種別情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { getMeasureType } from '@/api/axios';

export default {
  setup() {
    const title = ref('測定種別情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const measure_type = ref({});
    const route = useRoute();
    const measureTypeId = route.params.id;

    const fetchMeasureType = async () => {
      const response = await getMeasureType(measureTypeId);
      measure_type.value = response.data;
    };

    onMounted(fetchMeasureType);

    return {
      title,
      measure_type
    };
  }
};
</script>

<style scoped>
.detail-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
